import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getBondList(data) {
  return request({
    url: '/api/mdm-service/bondManagement/list',
    method: 'post',
    data
  })
}

export function getBondStatistics(data) {
  return request({
    url: '/api/mdm-service/bondManagement/statistics',
    method: 'post',
    data
  })
}

export function saveBond(data) {
  return request({
    url: '/api/mdm-service/bondManagement/save',
    method: 'post',
    data
  })
}

export function updateBond(data) {
  return request({
    url: '/api/mdm-service/bondManagement/update',
    method: 'post',
    data
  })
}

export function batchVerify(data) {
  return request({
    url: '/api/mdm-service/bondManagement/batchVerify',
    method: 'post',
    data
  })
}

export function batchInvalid(uuids) {
  return request({
    url: '/api/mdm-service/bondManagement/batchInvalid',
    method: 'post',
    data: uuids
  })
}

export function getBondLog(bondUuid) {
  return request({
    url: '/api/mdm-service/bondManagement/log/' + bondUuid,
    method: 'get'
  })
}

// 根据清关行ID获取Bond信息
export function getBondByCustomsBrokerId(customsBrokerId) {
  return request({
    url: '/api/mdm-service/bondManagement/findByCustomsBrokerId',
    method: 'get',
    params: { customsBrokerId }
  })
}

// 获取有效和到期预警状态的Bond信息
export function getEffectiveAndWarningBonds() {
  return request({
    url: '/api/mdm-service/bondManagement/findEffectiveAndWarning',
    method: 'get'
  })
}

// ========== 美国州/城市字典接口 ==========

export function getUsStates() {
  return request({
    url: '/api/mdm-service/usArea/states',
    method: 'get'
  })
}

export function getUsCitiesByState(stateCode) {
  return request({
    url: '/api/mdm-service/usArea/cities',
    method: 'get',
    params: { stateCode }
  })
}

// ========== Bond管理专用文件操作接口（指向 mdm-service） ==========

export function bondUploadStorage(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.common.bondUpload,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

export function bondFindByFileId(fileId) {
  return request({
    url: URL.common.bondFindByFileId + '/' + encodeURIComponent(fileId),
    responseType: 'blob',
    method: 'get'
  })
}

export function bondGetFileInfo(fileId) {
  return request({
    url: URL.common.bondGetFileInfo + '/' + encodeURIComponent(fileId),
    method: 'get'
  })
}

export function bondDeleteFile(fileId) {
  return request({
    url: URL.common.bondDeleteFile + '/' + encodeURIComponent(fileId),
    method: 'post'
  })
}

export function bondConvertFileByFileId(fileId, targetFileType) {
  return request({
    url: URL.common.bondConvertFileByFileId + '/' + encodeURIComponent(fileId) + '/' + targetFileType,
    responseType: 'blob',
    method: 'get'
  })
}
